import { Box, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import scroll from "scroll"
import scrollDoc from "scroll-doc"

import { jewlr_t } from "helpers/application"

import { GemLink } from "./components"
import TitleSection from "./titleSection"

const gemstonesTitles = [
  { key: "genuineGemtones", text: "Genuine Gemstones" },
  { key: "simulatedGemtones", text: "Simulated Gemstones" },
  { key: "zirconiaGemtones", text: "Brilliance Cubic Zirconia" },
]

const Banner = ({ refs }) => {
  let description = (
    <>
      Add a touch of {jewlr_t("terms.color")} and meaning to your{" "}
      {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")} with our
      gemstone collections, or choose the sparkle of{" "}
      <GemLink data-lc="banner" fontSize={18} to="/info/diamond">
        natural
      </GemLink>{" "}
      or{" "}
      <GemLink
        data-lc="banner"
        fontSize={18}
        to="/helpdesk/a/898/how-are-lab-diamonds-made"
      >
        lab diamonds
      </GemLink>
      .
    </>
  )

  const scrollToGemstone = (e, title) => {
    const page = scrollDoc()
    e.preventDefault()
    let gemRef = refs[title]
    const offset = gemRef.offsetTop - 120
    scroll.top(page, offset)
  }
  return (
    <Box bg="polar" py={4} textAlign="center">
      <Box contain>
        <Image
          alt="Gemstones"
          src={`${sl.config.jewlr_asset_url}images/info/jewlr/gemstones/gemstone.png`}
          width="500px"
        />
        <TitleSection text={description} title="Gemstones" />
        <Box display={{ _: "flex", tablet: "block" }} flexDirection="column">
          {gemstonesTitles.map((title) => (
            <GemLink
              fontSize={20}
              key={title.text}
              onClick={(e) => scrollToGemstone(e, title.key)}
              pb={{ _: 4, tablet: 0 }}
              px={3}
            >
              {title.text}
            </GemLink>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

Banner.propTypes = {
  refs: PropTypes.object,
}

export default Banner
